import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import lodash from 'lodash';

import { useAppLogic } from '../../hooks/AppLogicHook';
import { useUrlParams } from '../../hooks/UrlParamsHook';
import ChartContainer from './ChartContainer';
import Controller from './Controller';
import styles from './styles.module.scss';

const ControlArea = () => {
  const [intensity, setIntensity] = useState(0);
  const [positions, setPositions] = useState({ max: true, mid: true, min: true });
  const [isRangeMode, setIsRangeMode] = useState(true);
  const [customSettings, setCustomSettings] = useState({
    suctionPower: 67, // %
    suctionTime: 3000, // ms
    vacuumHold: 1000, // ms
    pauseTime: 1000, // ms
    isRunning: false,
  });

  const navigate = useNavigate();

  const { isExpired, sendPercent, sendPowerShotMotors, isPowerShotConnected } = useAppLogic();
  const [firstMotorPercent, setFirstMotorPercent] = useState(0);
  const [secondMotorPercent, setSecondMotorPercent] = useState(0);
  const { roomNumber } = useUrlParams();

  useEffect(() => {
    if (!isExpired || !roomNumber) {
      return;
    }
    navigate(`/expired/${roomNumber}`);
  }, [isExpired, navigate, roomNumber]);

  const send = useCallback(
    lodash.throttle((newIntensity) => {
      sendPercent(newIntensity, positions, isRangeMode);
    }, 300),
    [sendPercent, positions, isRangeMode],
  );

  useEffect(() => {
    send(intensity);
  }, [intensity, positions, isRangeMode, customSettings]);

  const sendPowerShot = useCallback(
    lodash.throttle((left, right) => {
      sendPowerShotMotors(left, right);
    }, 100),
    [sendPowerShotMotors],
  );

  useEffect(() => {
    if (!isPowerShotConnected) { return; }
    sendPowerShot(firstMotorPercent, secondMotorPercent);
  }, [firstMotorPercent, secondMotorPercent]);

  return (
    <div className={styles.container}>
      <ChartContainer intensity={intensity} positions={positions} isRangeMode={isRangeMode} />
      <Controller
        intensity={intensity}
        setIntensity={setIntensity}
        positions={positions}
        setPositions={setPositions}
        isRangeMode={isRangeMode}
        setIsRangeMode={setIsRangeMode}
        customSettings={customSettings}
        setCustomSettings={setCustomSettings}
        isPowerShotConnected={isPowerShotConnected}
        firstMotorPercent={firstMotorPercent}
        setFirstMotorPercent={setFirstMotorPercent}
        secondMotorPercent={secondMotorPercent}
        setSecondMotorPercent={setSecondMotorPercent}
      />
    </div>
  );
};

export default ControlArea;
